import React, { Component } from 'react';
import { config, SERVICE_API, VIEW_NAME, DISPATCH_ID, ROLES } from '../libs/utils/Const';
import {connect} from "react-redux";
import {ItemDetailsModal} from "./index";
import CurrencyFormat from 'react-currency-format';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './ItemSlider.css';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import moment from 'moment';

// definir las variables responsivas para el carrusel
const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1920 },
        items: 4,
        partialVisibilityGutter: 80 // this is needed to tell the amount of px that should be visible.
    },
    desktop2: {
        breakpoint: { max: 1920, min: 1608 },
        items: 4,
        partialVisibilityGutter: 80 // this is needed to tell the amount of px that should be visible.
    },
    desktop3: {
        breakpoint: { max: 1608, min: 1200 },
        items: 3,
        partialVisibilityGutter: 80 // this is needed to tell the amount of px that should be visible.
    },
    tablet: {
      breakpoint: { max: 1200, min: 992 },
      items: 2,
      partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
    },
    tablet1: {
      breakpoint: { max: 992, min: 767 },
      items: 2,
      partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
    },
    tablet2: {
        breakpoint: { max: 767, min: 464 },
        items: 1,
        partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
      },
    mobile: {
      breakpoint: { max: 463, min: 0 },
      items: 1,
      partialVisibilityGutter: 30 // this is needed to tell the amount of px that should be visible.
    }
}

class ItemSlider2 extends Component {

    constructor(props){
        super(props);
        this.state = {
            seller: JSON.parse(localStorage.getItem(config.general.localStorageNamed + 'PartnerUser')),
        };
        this.mouseOverAddCart = this.mouseOverAddCart.bind(this);
        this.mouseOutAddCart = this.mouseOutAddCart.bind(this);
        this.iconMouse = [];     
        this.iconMouseOver = []; 
    }

    changeQuantity = (index, item, event) =>{
        const {changeQuantity, notificationReducer: {showAlert},itemsReducer: {items2: itemsSearch}} = this.props; 
         let newQuantity ;
        itemsSearch.map( itemFilter => {
            if (itemFilter.ItemCode === item.ItemCode) {
                newQuantity = itemFilter.quantity || '1';
            }
        });
        
        let onHand = item.OnHand;   
        if(newQuantity > onHand) {
            newQuantity = onHand;
        }
        if( Number(newQuantity) < 1 ){
            changeQuantity(index,item, newQuantity, false); //delete
            showAlert({type: 'warning', message: "Se excede el número de articulos disponibles de este producto", timeOut: 2500});
        }else{
            changeQuantity(index,item, newQuantity, true); // add
        }        
    };

    changLocalQuantity = (index, item, event)=>{
        const {itemsReducer: {items2: itemsSearch}, notificationReducer: {showAlert}} = this.props;
        let newQuantity =  event.nativeEvent.target.value;
        itemsSearch.map( itemFilter => {
            if (itemFilter.ItemCode === item.ItemCode) {
                if(item.OnHandPrincipal - item.IsCommited >= parseInt(newQuantity)){
                    itemFilter.quantity = newQuantity;
                }
                else{
                    showAlert({type: 'warning', message: "Se excede el número de articulos disponibles de este producto", timeOut: 2500});
                }
            }
        });
        this.applyFilters(itemsSearch);
    }

    setSepecialPrice = (itemParameter) =>{
        let item = itemParameter;
        const {itemsReducer: {specialPrice}} = this.props;
        
        let CardCode = specialPrice.CardCode;
        let PriceList = specialPrice.ListNum && specialPrice.ListNum !== '' ? specialPrice.ListNum : specialPrice.priceList;
        
        // Special Prices Validation
        //########################################################################################################################
        let priority2 = "*" + PriceList;
        let formattedDocDate = moment().format('YYYY/MM/DD');

        let flagSN = true; // Socio de negocio
        let flagPriceList = true; // Lista de precios
        let flagPricePriority = true;
        let maxQuantity = 0; // Cantidad maxima a alegir
        let priceItem = -1;
        let discount = -1;
        let priceBeforeDisc= -1;

        item.QuantitySpecial = item.quantity;
        item.Price = -1;

        // Socio de negocios
        if(specialPrice.specialPrices.length > 0){
            specialPrice.specialPrices.map((itemPrice) => {
                if (item.ItemCode == itemPrice.ItemCode && itemPrice.CardCode == CardCode) {
                    if (itemPrice.children.length > 0) {
                        itemPrice.children.map((child) => {
                            let inicial = new Date(child.FromDate);
                            let final = new Date(child.ToDate || formattedDocDate);
                            let docDate = new Date(formattedDocDate);
                            
                            inicial.setMinutes(inicial.getMinutes() + inicial.getTimezoneOffset());
                            final.setMinutes(final.getMinutes() + final.getTimezoneOffset());

                            inicial.setHours(0, 0, 0, 0);
                            final.setHours(0, 0, 0, 0);
                            docDate.setHours(0, 0, 0, 0);

                            if (docDate >= inicial && docDate <= final) {
                                if (itemPrice.childrenCantidades.length > 0) {
                                    // Cantidades
                                    itemPrice.childrenCantidades.map((child2) => {
                                        let inicialCantidad = new Date(child2.FromDate);
                                        let finalCantidad = new Date(child2.ToDate || formattedDocDate);

                                        if(docDate >= inicialCantidad && docDate <= finalCantidad){
                                            if ((item.QuantitySpecial || 1) >= child2.Amount) {
                                                if(child2.Amount > maxQuantity) {
                                                    maxQuantity = child2.Amount;
                                                    item.DiscountPercentSpecial = child2.Discount;
                                                    flagPricePriority = false;
                                                    priceItem = parseFloat(child2.Price);
                                                    discount = parseFloat(child2.Discount);
                                                    priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                                }
                                            }
                                        }
                                    });
                                    if(maxQuantity != 0){
                                        flagSN = false;
                                    }
                                    if(flagSN){
                                        // Fechas
                                        item.DiscountPercentSpecial = child.Discount;
                                        flagPricePriority = false;
                                        priceItem = parseFloat(child.Price);
                                        discount = parseFloat(child.Discount);
                                        priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                        flagSN = false;
                                    }
                                } else {
                                    // Fechas
                                    item.DiscountPercentSpecial = child.Discount;
                                    flagPricePriority = false;
                                    priceItem = parseFloat(child.Price);
                                    discount = parseFloat(child.Discount);
                                    priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                    flagSN = false;
                                }
                            } else {
                                // General
                                if(flagSN){
                                    item.DiscountPercentSpecial = itemPrice.Discount;
                                    flagPricePriority = false;
                                    priceItem = parseFloat(itemPrice.Price);
                                    discount = parseFloat(itemPrice.Discount);
                                    priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                }
                            } 
                        })
                    } else {                           
                        //General
                        item.DiscountPercentSpecial = itemPrice.Discount;
                        flagPricePriority = false;
                        priceItem = parseFloat(itemPrice.Price);
                        discount = parseFloat(itemPrice.Discount);
                        priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                    }
                }
            });
        }
        // Lista de inventario
        if(specialPrice.specialPricesList.length > 0 && flagPricePriority){
            specialPrice.specialPricesList.map((itemPrice2)  => {
                if(itemPrice2.ItemCode == item.ItemCode && itemPrice2.CardCode == priority2){
                    if (itemPrice2.children.length > 0) {
                        itemPrice2.children.map((child)=> {

                            let inicial = new Date(child.FromDate);
                            let final = new Date(child.ToDate || formattedDocDate);
                            let docDate = new Date(formattedDocDate);
                            
                            inicial.setMinutes(inicial.getMinutes() + inicial.getTimezoneOffset());
                            final.setMinutes(final.getMinutes() + final.getTimezoneOffset());

                            inicial.setHours(0, 0, 0, 0);
                            final.setHours(0, 0, 0, 0);
                            docDate.setHours(0, 0, 0, 0);
                            if (docDate >= inicial && docDate <= final) {
                                if (itemPrice2.childrenCantidades.length > 0) {
                                    // Cantidades
                                    itemPrice2.childrenCantidades.map((child2) => {
                                        let inicialCantidad = new Date(child2.FromDate);
                                        let finalCantidad = new Date(child2.ToDate || formattedDocDate);

                                        if(docDate >= inicialCantidad && docDate <= finalCantidad){
                                            if ((item.QuantitySpecial || 1) >= child2.Amount) {
                                                if(child2.Amount > maxQuantity) {
                                                    maxQuantity = child2.Amount;
                                                    item.DiscountPercentSpecial = child2.Discount;
                                                    flagPricePriority = false;
                                                    priceItem = parseFloat(child2.Price);
                                                    discount = parseFloat(child2.Discount);
                                                    priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                                }
                                            }
                                        }
                                    });
                                    if(maxQuantity != 0){
                                        flagPriceList = false;
                                    }
                                    if(flagPriceList){
                                        // Fechas
                                        item.DiscountPercentSpecial = child.Discount;
                                        flagPricePriority = false;
                                        priceItem = parseFloat(child.Price);
                                        discount = parseFloat(child.Discount);
                                        priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                        flagPriceList = false;
                                    }
                                } else {
                                    // Fechas
                                    item.DiscountPercentSpecial = child.Discount;
                                    flagPricePriority = false;
                                    priceItem = parseFloat(child.Price);
                                    discount = parseFloat(child.Discount);
                                    priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                    flagPriceList = false;
                                }
                            } else {
                                // General
                                if(flagPriceList){
                                    item.DiscountPercentSpecial = itemPrice2.Discount;
                                    flagPricePriority = false;
                                    priceItem = parseFloat(itemPrice2.Price);
                                    discount = parseFloat(itemPrice2.Discount);
                                    priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                                }
                            } 
                        })
                    } else {
                        // General
                        item.DiscountPercentSpecial = itemPrice2.Discount;
                        flagPricePriority = false;
                        priceItem = parseFloat(itemPrice2.Price);
                        discount = parseFloat(itemPrice2.Discount);
                        priceBeforeDisc = ((100 * priceItem) / (100 - discount)).toFixed(0);
                    }
                }
            });
        } 
        //No tiene precio especial
        if(flagPricePriority){
            item.DiscountPercentSpecial = 0;
        }

        // Precios por descuentos especiales
        if(priceBeforeDisc != -1){
            item.Price = Number(priceItem);
            item.PriceBeforeDiscount = Number(priceBeforeDisc);
        }
        
        let priceTax = item.Price !== -1 ? Number(((item.Price * (16 / 100)) + item.Price).toFixed(0)) : -1;
        return priceTax;
    }

    // No aplica
    changeBackOrder= (item, addItem) => {
        const {itemsReducer : {deleteBackOrder, addBackOrder}} = this.props;
        if(addItem){
            addBackOrder({item, quantity: 1})
        }else{
            deleteBackOrder({item, deleteAll: false});
        }
    };
    
    applyFilters = data => {
        const {setItemsFilterSearch2} = this.props;
        setItemsFilterSearch2(data);
    };

    mouseOverAddCart = (index, flag, event)=>{
        if(this.iconMouse && this.iconMouse.length > 0){
            this.iconMouse[index].style.display = "none";
            this.iconMouseOver[index].style.display = "block";
        }
    }

    mouseOutAddCart = (index, flag, event)=>{
        if(flag == 'green'){
            event.currentTarget.style.backgroundColor = "#232323";
            event.currentTarget.className = "btn btn-block botonAgregar"
        } else if(flag == 'yellow'){
            event.currentTarget.style.backgroundColor = "#232323";
            event.currentTarget.className = "btn btn-block botonAgregarYellow"
        } else {
            event.currentTarget.style.backgroundColor = "#e27753";
            event.currentTarget.className = "btn btn-block botonAgregarAgotado"
        }
        // Íconos
        if(this.iconMouse && this.iconMouse.length > 0){
            this.iconMouse[index].style.display = "block";
            this.iconMouseOver[index].style.display = "none";
        }
    }

    render() {
        const {itemsReducer : { items2, searchItemsFilter, updateFavorite, deleteShoppingCart, openItemDetails }, dashboard, changeBackOrder, sessionReducer: { role }, } = this.props;
        const { seller } = this.state;
        let valor = seller ? seller.U_FMB_Handel_Perfil : '0';

        return (
            <div>
                <ItemDetailsModal view={VIEW_NAME.ITEMS_VIEW}/>
                <div className="SliderItems">
                    <Carousel autoPlay partialVisible={false} infinite={true} responsive={responsive} autoPlaySpeed={5000} removeArrowOnDeviceType={["tablet", "mobile","tablet1","tablet2"]} >
                        {items2 && items2.map((item, index) => {
                            item.ItemName = item.ItemName || '';
                            let dashboardForTwoSliders = dashboard ? dashboard : '';
                            // let imagesArray = item.U_Handel_ImagesArray || '';
                            // imagesArray = imagesArray.split('|');
                            // let imagenShow = imagesArray[0] ? (config.BASE_URL + SERVICE_API.getImage + '/' + imagesArray[0]) : require('../images/noImage.png');
                            let imagenShow = item.PicturName ? (config.BASE_URL + SERVICE_API.getImage + '/' + item.PicturName) : require('../images/noImage.png');                            
                            
                            return (
                                <div id="ItemsSlider" style={{ display:"flex", justifyContent:"center", maxWidth:"27rem",position:"relative" }} key={index}>
                                    <div className="item card" style={{ position:"relative", textAlign:"center" , width: "303.41px", minHeight:"420px", padding:"1rem", backgroundColor: config.itemsList.backgroundColor }}>
                                        <div className="imageCard">
                                            <div style={{display: (!item.U_FMB_Handel_Promo || item.U_FMB_Handel_Promo === '' || item.U_FMB_Handel_Promo == 0 ? 'none' : 'table')}}>
                                                <div className="font-weight-bold mt-1"  style={{position: "absolute"}} onClick={() => openItemDetails(item)}>
                                                    <span style={{backgroundColor: "#BE1824", padding:"8px", borderRadius:"10px"}}>
                                                        <blink>OFERTA</blink>
                                                    </span>
                                                </div>
                                            </div>
                                            <img
                                                onClick={() => openItemDetails(item)}
                                                className="card-img-top cardImg"
                                                src={imagenShow}
                                                alt="Imagen del articulo"
                                            />
                                            <div className="card-body" style={{margin: 0, padding: "10px",height: "135px", color: config.itemsList.textColor}}>
                                                <div>
                                                    <div className="overflow-auto ItemName">
                                                        <p className="card-title text-left" style={{fontWeight:"bold", padding: 1, fontSize: 18, color: config.itemsList.textPrice2}}>
                                                            {item.ItemName ? (item.ItemName).length > 44 ? (item.ItemName).substring(0, 43) + " ... ": item.ItemName : " "}
                                                        </p>
                                                    </div>
                                                    
                                                    {item && item.SalUnitMsr ? 
                                                    <div className="overflow-auto">
                                                        <p 
                                                        className="text-left ItemSalUnitMsr"
                                                        style={{                               
                                                            padding: 1,
                                                            fontSize: "1rem",
                                                            color: config.itemsList.textPrice2,
                                                        }}>
                                                            UND:{item.SalUnitMsr || ''}
                                                        </p>
                                                    </div>:''
                                                    }  
                                                    {role === ROLES.PUBLIC ?
                                                    <></>
                                                    :<>
                                                    <p className="card-subtitle text-left" style={{ fontSize: "1rem", marginLeft: 2, color: config.itemsList.textPrice2 }}>
                                                        {item.U_web === 0 || item.U_web === null
                                                            ? "Solicite su cotización"
                                                            // : (valor == '0' || !item.U_FMB_Handel_Promo || item.U_FMB_Handel_Promo === '' || item.U_FMB_Handel_Promo == 0 || item.DiscountPercentSpecial == 0 ?
                                                            :<div>

                                                            <CurrencyFormat
                                                                    value={Number(item.Price)}
                                                                    displayType={'text'}
                                                                    thousandSeparator={'.'}
                                                                    decimalSeparator = {false} 
                                                                    fixedDecimalScale={true}
                                                                    decimalScale={0}
                                                                    prefix={'$'}
                                                                    suffix = {''}>
                                                                </CurrencyFormat>
                                                                <span> más IVA</span>
                                                                </div>
                                                         }
                                                          {/* : <>
                                                                    <span className="precioPromocion row justify-content-start ml-md-2 pl-2">
                                                                        <CurrencyFormat
                                                                            value={Number(item.PriceBeforeDiscount)}
                                                                            displayType={'text'}
                                                                            thousandSeparator={'.'}
                                                                            decimalSeparator = {false} 
                                                                            fixedDecimalScale={true}
                                                                            decimalScale={0}
                                                                            prefix={'$'}
                                                                            suffix = {''}>
                                                                        </CurrencyFormat>
                                                                    </span>
                                                                    <span className="precioPromocionItemList">
                                                                        <div className="preciosItemSlider row justify-content-start">
                                                                            <div className="pricePromoItemSlider col-md-auto ml-md-1" style = {{fontSize: 'xx-large'}}>
                                                                                <CurrencyFormat
                                                                                    value={Number(item.Price)}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator={'.'}
                                                                                    decimalSeparator = {false} 
                                                                                    fixedDecimalScale={true}
                                                                                    decimalScale={0}
                                                                                    prefix={'$'}
                                                                                    suffix = {''}>
                                                                                </CurrencyFormat>
                                                                            </div>
                                                                            {seller ? seller.U_FMB_Handel_Perfil != '0' && item.DiscountPercentSpecial !== 0 ? 
                                                                                <div className="descuento col-md-4 align-middle text-right">
                                                                                    <span className = "text-danger">{parseFloat(item.DiscountPercentSpecial).toFixed(0)}% OFF</span>
                                                                                </div>
                                                                                : "" : ""
                                                                            }
                                                                        </div>
                                                                    </span>
                                                                
                                                                </>
                                                            ) 
                                                        } */}
                                                        {item.U_web === 1 &&
                                                            " " //+ item.currency
                                                        }
                                                    </p>
                                                    </>}
                                                    <div className="overflow-auto">
                                                        <p 
                                                        className="text-left"
                                                        style={{                               
                                                            padding: 1,
                                                            fontSize: 12,
                                                            fontWeight: "normal",
                                                            color: "#808080",
                                                        }}>
                                                            {item.ItemCode || ''}
                                                        </p>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div className="card-footer" style={{ padding: 0, border: 'none', marginTop: "21px"}}>
                                            <div className="row text-center" style={{margin: 0, padding: 0}}>
                                            {role === ROLES.PUBLIC ?
                                                <div className="col-12 d-flex justify-content-center">
                                                <button className="btn font-weight-bold" onClick={() => {}} style={{cursor: 'default', background: 'black', color: 'white'}}>SOLICITE UNA COTIZACIÓN</button>
                                                </div>
                                            :
                                            <>
                                                {item.U_web === 0 || item.U_web === null ?
                                                    <div className="col-12" style={{padding:0}}>
                                                        <label style={{textAlign: "center", fontSize: 16}}>Llámenos o envíe un correo</label>
                                                    </div> :
                                                    <div className={item.SalUnitMsr === "KG"? "cantidad":"col-3 cantidad"} style={item.SalUnitMsr === "KG"?{width:  "8rem"}:{width:  "5rem"}}>
                                                        
                                                         {item.Unidades === "Unidades" ?
                                                                <input
                                                                disabled={!(!!item.OnHandPrincipal)}
                                                                id={'input-quantity-' + item.ItemCode + index}
                                                                type="number"
                                                                min="1"
                                                                value={item.quantity ? Number(item.quantity).toFixed(0) : ''}
                                                                className="form-control"
                                                                name={'quantity' + item.ItemCode}
                                                                placeholder="1"
                                                                style={{textAlign: "left", background: '#FFFFFF', marginTop: 1, height: 44.5, borderRadius:"0.7rem"}}
                                                                onChange={(event) => {this.changLocalQuantity(index, item, event, item.SalUnitMsr)}}
                                                                //onKeyDown={event => event.keyCode == 13 && this.addShoppingCart(item, 'input-quantity-' + item.ItemCode + index)}
                                                            />
                                                            :item.SalUnitMsr === "KG"?
                                                                <div class="input-group">
                                                                    <input
                                                                        disabled={!(!!item.OnHandPrincipal)}
                                                                        id={'input-quantity-' + item.ItemCode + index}
                                                                        type="number"
                                                                        min={(item.SalPackUn || 1)}
                                                                        step={(item.SalPackUn || 1)}
                                                                        value={Number(item.quantity <= item.SalPackUn ?item.SalPackUn: item.quantity)}
                                                                        className="form-control"
                                                                        name={'quantity' + item.ItemCode}
                                                                        // placeholder={(item.SalPackUn || 1)}
                                                                        style={{textAlign: "left", background: '#FFFFFF', marginTop: 1, height: 44.5, width: "75px",borderTopLeftRadius:"0.7rem", borderBottomLeftRadius:"0.7rem"}}
                                                                        onChange={(event) => {this.changLocalQuantity(index, item, event, item.SalUnitMsr)}}
                                                                        onKeyDown={(event) => event.preventDefault()}
                                                                        //onKeyDown={event => event.keyCode == 13 && this.addShoppingCart(item, 'input-quantity-' + item.ItemCode + index)}
                                                                    />
                                                                    <div class="input-group-append">
                                                                        <span class="input-group-text" id="basic-addon1" style={item.OnHandPrincipal <= 0 ?{background: "#e27753", border: "transparent", color: "black", fontWeight: "bold", borderTopRightRadius:"0.7rem", borderBottomRightRadius:"0.7rem"}: {background: "#232323", border: "transparent", color: "white", fontWeight: "bold", borderTopRightRadius:"0.7rem", borderBottomRightRadius:"0.7rem"}}>
                                                                            {item.SalUnitMsr}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <input
                                                                    disabled={!(!!item.OnHandPrincipal)}
                                                                    id={'input-quantity-' + item.ItemCode + index}
                                                                    type="number"
                                                                    min={(item.SalPackUn || 1)}
                                                                    step={(item.SalPackUn || 1)}
                                                                    value={Number(item.quantity <= item.SalPackUn ?item.SalPackUn: item.quantity)}
                                                                    className="form-control"
                                                                    name={'quantity' + item.ItemCode}
                                                                    placeholder="1"
                                                                    style={{textAlign: "left", background: '#FFFFFF', marginTop: 1, height: 44.5, width: "65px",borderRadius:"0.7rem"}}
                                                                    onChange={(event) => {this.changLocalQuantity(index, item, event, item.SalUnitMsr)}}
                                                                    //onKeyDown={event => event.keyCode == 13 && this.addShoppingCart(item, 'input-quantity-' + item.ItemCode + index)}
                                                                />
                                                            }
                                                    </div>
                                                }
                                                {item.U_web === 0 || item.U_web === null ? 
                                                    <div><label style={{textAlign: "center", fontSize: 16}}>Para cotización</label></div>: 
                                                    <div className="col-6 botonAgregar">
                                                        <button style={{textAlign: "center"}} 
                                                            type="button" 
                                                            readOnly = {(item.OnHandPrincipal - item.IsCommited) <= 0 || item.OnHandPrincipal === '' ? true : false}
                                                            className= {item.flag === 'green' ? "btn btn-block botonAgregar": "btn btn-block botonAgregarAgotado"}  
                                                            value={(item.quantity ? Number(item.quantity): '1')} 
                                                            onClick={(event)=>{this.changeQuantity(index, item, event)}} 
                                                            onMouseOver={item.SalUnitMsr == "KG"? "" :(event)=>{this.mouseOverAddCart(dashboardForTwoSliders.toString() +index, item.flag, event)}} 
                                                            onMouseOut={item.SalUnitMsr == "KG"? "" :(event)=>{this.mouseOutAddCart(dashboardForTwoSliders.toString() +index, item.flag, event)}}
                                                        >
                                                        </button>
                                                    </div>
                                                }
                                                {item.SalUnitMsr !== "KG" &&
                                                    <>
                                                        {((item.U_web !== 0 && item.U_web !== null) && (item.OnHandPrincipal == 0 || item.OnHandPrincipal == '')) &&
                                                                <div className="icoCarrito col-3 text-center align-middle" style={{fontSize: 33,padding:0, textAlign: "right"}}>
                                                                    {/* <img ref={iconMouse => this.iconMouse[dashboardForTwoSliders.toString() +index] = iconMouse} src={config.shoppingCartIcons.carritoAgotado} style={{display: "block", color: "red", cursor: "pointer"}}/>
                                                                    <img ref={iconMouseOver => this.iconMouseOver[dashboardForTwoSliders.toString() +index] = iconMouseOver} src={config.shoppingCartIcons.carritoAgotado} style={{display: "none", color: "red", cursor: "pointer"}}/> */}
                                                                    <i class="fa fa-shopping-cart m-3 " aria-hidden="true" style={{ fontSize: "25px", color: "#e27753" }}></i>
                                                                </div>
                                                        }
                                                        {((item.U_web !== 0 && item.U_web !== null) && (item.OnHandPrincipal - item.IsCommited) > 0 && (item.flag === 'green' || item.flag === 'yellow')) &&
                                                                <div className="icoCarrito col-3 text-center align-middle" style={{fontSize: 33,padding:0, textAlign: "right"}}>
                                                                    {/* <img ref={iconMouse => this.iconMouse[dashboardForTwoSliders.toString() +index] = iconMouse} src={item.flag === 'green' ? config.shoppingCartIcons.carritoVerde : config.shoppingCartIcons.carritoAmarillo} style={{display: "block", cursor: "pointer"}}/>
                                                                    <img ref={iconMouseOver => this.iconMouseOver[dashboardForTwoSliders.toString() +index] = iconMouseOver} src={item.flag === 'green' ? config.shoppingCartIcons.carritoVerde : config.shoppingCartIcons.carritoAmarillo} style={{display: "none", cursor: "pointer"}}/> */}
                                                                    <i class="fa fa-shopping-cart m-3" aria-hidden="true" style={{ fontSize: "25px", color: "#232323" }} ></i>
                                                                </div>
                                                        }
                                                    </>
                                                }
                                            </>}
                                            </div>
                                            <div className="row text-center" style={{ margin: 0, padding: 0 }}>
                                                {item.U_web === 0 || item.U_web === null 
                                                    ? item.wishlist === 1 &&
                                                        <div className="col-12" style={{ padding: 0 }}>
                                                            <label style={{ textAlign: "center", fontSize: 16 }}>para cotización</label>
                                                        </div>
                                                    : item.wishlist === 1 &&
                                                        <div className="col-10">
                                                            <label style={{ textAlign: "center", marginTop: 12, fontSize: 14 }}>Lista de deseos</label>
                                                        </div>
                                                }
                                                {item.U_web === 1 &&
                                                    item.wishlist === 1 &&
                                                        <div className="col-2" style={{ color: config.navBar.textColor2, fontSize: 20, padding: 0 }}>
                                                            {item.backOrder
                                                                ? <i className={config.icons.backOrderFalse} style={{ cursor: "pointer", marginLeft: 7, marginTop: 15 }} onClick={() => changeBackOrder(item, false)} />
                                                                : <i className={config.icons.backOrderTrue} style={{ cursor: "pointer", marginLeft: 7, marginTop: 15 }} onClick={() => changeBackOrder(item, true)} />
                                                            }
                                                        </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Carousel>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        notificationReducer: store.NotificationReducer,
        shoppingCartReducer: store.ShoppingCartReducer,
        itemsReducer: store.ItemsReducer,
        sessionReducer: store.SessionReducer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setUser: value => dispatch({type: DISPATCH_ID.LOGIN_SET_USER, value}),
        setShoppingCart: value => dispatch({type: DISPATCH_ID.SHOPPING_CART_SAVE_CART, value}),
        setItemsFilterSearch2: value => dispatch({type: DISPATCH_ID.ITEMS_SAVE_ITEMS_FILTER2, value}),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ItemSlider2);